import React, { useEffect, useState } from 'react';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { useParams } from 'react-router-dom';
import 'react-html5video/dist/styles.css';
import { fetchQuestionsByModule } from '../../../requests/learning';
import Question from './Question';
import Results from './Results';
import { AppHeader } from '../../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { Wrapper, ContentQuiz, HeaderContainer } from './Quizzes.styled';

const TakeQuiz = () => {
  const [learningModule, setLearningModule] = useState<any>(null);
  const { id } = useParams();
  const moduleId = Number(id);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(undefined);
  const [quizScore, setQuizScore] = useState(0.0);
  const [questionsCount, setQuestionCount] = useState(-1);
  const { t } = useTranslation();

  const isLastQuestion = questionsCount === questionIndex;

  const nextQuestionHandler = () => {
    setQuestionIndex((prevState) => prevState + 1);
  };

  useEffect(() => {
    (async () => {
      const { data } = await fetchQuestionsByModule(moduleId);
      setLearningModule(data);
      setCurrentQuestion(data.questions[questionIndex]);
      setQuestionCount(data.questions.length);
    })();
  }, []);

  useEffect(() => {
    if (!learningModule || !learningModule.questions || isLastQuestion) {
      return;
    }
    setCurrentQuestion(learningModule.questions[questionIndex]);
  }, [questionIndex]);

  return (
    <Wrapper>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.LEARNING.TITLES.TAKE_QUIZ')}
          hasBackButton={true}
        />
      </HeaderContainer>
      <ContentQuiz>
        {!learningModule || !currentQuestion ? (
          <LoadingContent layout="flex" />
        ) : isLastQuestion ? (
          <Results
            questionsCount={questionsCount}
            module={learningModule}
            score={quizScore}
          />
        ) : (
          <Question
            data={currentQuestion}
            nextQuestionHandler={nextQuestionHandler}
            setQuizScore={setQuizScore}
          />
        )}
      </ContentQuiz>
    </Wrapper>
  );
};

export default TakeQuiz;
